export default function addHeaderClassesToHtml(html: string): string {
  return `<div class="ck ck-content ck-editor__editable ck-rounded-corners ck-editor__editable_inline ck-blurred">${html}</div>`;
}
